import Typography from '@mui/material/Typography';
import moment from 'moment-timezone';

import Dialog from '@/components/Dialog';
import FAIcon from '@/components/Icon/FAIcon';
import Link from '@/components/Link';
import ERROR_CODES from '@/core/apiErrorCodes';
import { warningAmber } from '@/theme/colors';

const MAX_ITEMS = 10;

export interface ActivityRecord {
  id: string;
  name?: string;
  starts_at?: string;
  expert_id?: string;
}

function ConsultationStatus({ startsAt }: { startsAt?: string }) {
  const m = startsAt ? moment(startsAt) : null;
  const confirmed = m?.isValid();
  const text = confirmed ? `Starts at: ${m!.format('MMMM DD, YYYY')}` : 'Status: Scheduling';
  return <div style={{ fontSize: 14, color: '#666', marginTop: 2 }}>{text}</div>;
}

export interface ActivityGuardModalProps {
  open: boolean;
  onClose: () => void;
  error: { code: string; message: string; records: ActivityRecord[] } | null;
}

export function ActivityGuardModal({
  open,
  onClose,
  error,
}: ActivityGuardModalProps): JSX.Element | null {
  if (!error) return null;

  const isConsultations = error.code === ERROR_CODES.TEAM_MEMBER_HAS_ACTIVE_CONSULTATIONS;
  const records: ActivityRecord[] = error.records ?? [];
  const visible = records.slice(0, MAX_ITEMS);
  const overflow = records.length - MAX_ITEMS;

  return (
    <Dialog open={open} title="Action Blocked" onCancel={onClose} cancelLabel="Close">
      <Typography variant="body1" sx={{ mb: 2 }}>
        {error.message}
      </Typography>

      <ul style={{ margin: 0, paddingLeft: 20 }}>
        {visible.map((record) =>
          isConsultations ? (
            <li key={record.id} style={{ marginBottom: 6 }}>
              Consultation:{' '}
              <Link to={`/consultation/${record.id}`} newTab>
                {record.id}
              </Link>
              <ConsultationStatus startsAt={record.starts_at} />
            </li>
          ) : (
            <li key={record.id} style={{ marginBottom: 6 }}>
              <FAIcon icon="star-o" size={14} color={warningAmber} style={{ marginRight: 4 }} />
              <Link to={`/expert_request/${record.id}`} newTab>
                {record.name}
              </Link>
            </li>
          )
        )}
      </ul>

      {overflow > 0 && (
        <Typography variant="body2" sx={{ mt: 1, color: 'text.secondary' }}>
          and {overflow} more...
        </Typography>
      )}
    </Dialog>
  );
}
